// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableLazy } from '@confluence/loadable';

import type { RestrictionsDialogMountPointProps } from './RestrictionsDialogMountPoint';
export { RestrictionsDialogTriggerWrapper } from './RestrictionsDialogTriggerWrapper';
export { RestrictionsDialogTrigger } from './RestrictionsDialogTrigger';
export { RestrictionsDialogMenuPropsProvider } from './RestrictionsDialogMenuPropsProvider';

export const LazyRestrictionsDialogMountPoint = LoadableLazy<RestrictionsDialogMountPointProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RestrictionsDialogMountPoint" */ './RestrictionsDialogMountPoint'
			)
		).RestrictionsDialogMountPoint,
});
